module.exports = __webpack_public_path__ + "img/resetpassword-icon.682af49c.svg";